export default __webpack_public_path__ + "static/media/EHFnpEMU4AAJzGb.6d12cf0e.jpg";